import React from 'react';
import MessageStatus from '@/pages/messages/components/message-status';
import MessageExpireTime from '../messageExpireTime';
import ContextMenuMessage from '../context-menu-message';
import styles from './index.module.scss';
import type { MessageTextProps } from './type';

const MessageText: React.FC<MessageTextProps> = ({
  className,
  isMe,
  message,
  chat,
  onClickStatus,
  displayTime,
}) => {
  // TODO
  const hasInfo = false;

  return (
    <ContextMenuMessage message={message} chat={chat}>
      <div
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        className={cls(
          styles.messageText,
          isMe && styles.messageTextBg,
          hasInfo && styles.hasInfo,
          className
        )}
      >
        <div className={styles.text}>{message.payload}</div>
        <div className={styles.operations}>
          {hasInfo && <div className={styles.left}></div>}
          <div className={styles.right}>
            <MessageExpireTime
              message={message}
              chat={chat}
              displayTime={displayTime}
            />
            <MessageStatus
              chat={chat}
              message={message}
              onClick={onClickStatus}
            ></MessageStatus>
          </div>
        </div>
      </div>
    </ContextMenuMessage>
  );
};

export default MessageText;
